module.exports = __webpack_public_path__ + "img/downaload-image.ac16e1ec.png";